<script setup lang="ts">
import type { ResponsiveImageType } from "vue-datocms";
import type { ImageLinkRecord } from "~~/server/graphql/datocms/generated";
import type { CreativeEventData } from "~/composables/useGtmTracking";
import { Image as DatocmsImage } from "vue-datocms";

const props = defineProps<{
  banner: ImageLinkRecord;
  index: number;
}>();

const localePath = useLocalePath();
const link = getImageLinkUrl(props.banner, localePath);
const creativeName = `Homepage Hero - Banner ${props.index + 1}`;
const creativeData: CreativeEventData = {
  creativeTitle: props.banner.title,
  creativeFileTitle: props.banner.image.title,
  creativeFileName: props.banner.image.filename,
  creativeHyperlink: link,
};

const { trackCreativeDisplayEvent, trackCreativeClickEvent } = useGtmTracking();
onMounted(() => {
  trackCreativeDisplayEvent(
    creativeName,
    creativeData,
  );
});
</script>

<template>
  <NuxtLink
    :to="link" :target="getImageLinkTarget(banner, localePath)"
    class="group" @click="trackCreativeClickEvent(creativeName, creativeData)"
  >
    <div class="overlay-container h-full">
      <div class="overlay-container__img">
        <div class="size-full overflow-hidden rounded-lg">
          <DatocmsImage
            v-if="banner.image" :data="banner.image.responsiveImage as ResponsiveImageType"
            :lazy-load="false" object-fit="cover" class="size-full transition-transform duration-300 ease-in-out group-hover:scale-105"
          />
        </div>
      </div>

      <div class="overlay-container__gradient z-10">
        <div class="size-full rounded-lg bg-linear-to-b from-transparent to-[#3C2828]" />
      </div>

      <div class="overlay-container__content z-20">
        <div class="p-md flex size-full flex-col justify-end">
          <div class="flex items-center justify-between">
            <h4 class="text-white">
              {{ banner.title }}
            </h4>

            <img src="/icons/arrow-circle-top-right-white.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<style scoped>
.overlay-container {
  display: grid;
  grid-template-areas: "stack";

  .overlay-container__img {
    grid-area: stack;
  }

  .overlay-container__gradient {
    grid-area: stack;
  }

  .overlay-container__content {
    grid-area: stack;
  }
}
</style>
